import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { SearchTextInput } from 'web-ui-components/lib/data/filter-and-search';
import { GridListToggle } from 'web-ui-components/lib/layout/content';

import PayeePickerToggle from './PayeePickerToggle';
import payeePickerContent, { contentPropTypes } from './PayeePicker.content';
import withContent from '../../../containers/withContent';
import withAddPayee from '../../../containers/withAddPayee';
import AddPayeeButton from '../../../sharedComponents/AddPayeeButton';
import { getPickerSearchPlaceholder } from '../../../states/accountPaging/utils/paging';
import { payeePropTypes } from '../../../sharedComponents/PayeeList/propTypes';

const PayeePickerHeader = ({
	onShowPayees,
	onShowAccounts,
	onToggleListView,
	showPayees,
	listViewSelected,
	onSearchTextChange,
	content,
	handleAddPayee,
	handleDisplayFullwidth = () => {},
	searchText,
	isManageYourPayee,
	ukPayees,
	onUKPayees,
	onInternationalPayees,
	isIFTEnabled,
	isAddPayeeEnable,
	onSearchTextSubmit,
	pageLoading,
	showPayeePickerToggle,
	selectedPayees = [],
}) => {
	const showAddPayeeButton = isAddPayeeEnable && (showPayees || isManageYourPayee) && !selectedPayees.length;

	const onAddPayeeHandler = () => {
		handleDisplayFullwidth();
		handleAddPayee();
	};

	return (
		<div data-test-id="account-picker-header" className="account-picker__header">
			<div
				data-test-id="account-picker-header-accountsViewToggle"
				className="account-picker__header__accountsViewToggle"
			>
				{showPayeePickerToggle && (
					<PayeePickerToggle
						isManageYourPayee={isManageYourPayee}
						onShowPayees={onShowPayees}
						onShowAccounts={onShowAccounts}
						ukPayees={ukPayees}
						onUKPayees={onUKPayees}
						onInternationalPayees={onInternationalPayees}
						showPayees={showPayees}
						content={content}
						isIFTEnabled={isIFTEnabled}
					/>
				)}
			</div>
			<div className="account-picker__header__searchContainer">
				<div
					data-test-id="account-picker-header-searchcontainer-search"
					className="account-picker__header__searchContainer__search"
				>
					<SearchTextInput
						onChange={onSearchTextChange}
						value={searchText}
						placeholder={getPickerSearchPlaceholder({ showPayees, isManageYourPayee, ukPayees, content })}
						aria-label="Search"
					/>
					<Button
						type="button"
						disabled={pageLoading || searchText.length < 3}
						display="primary"
						width="flush"
						onClick={onSearchTextSubmit}
					>
						{content.search}
					</Button>
				</div>
				{showAddPayeeButton && <AddPayeeButton onClick={onAddPayeeHandler} title={content.addPayeeButtonTitle} />}
				<GridListToggle
					onChange={(checked) => onToggleListView(!checked)}
					name="payee-picker-toggle-list-view"
					data-test-id="payee-picker-toggle-list-view"
					isListViewSelected={listViewSelected}
				/>
			</div>
		</div>
	);
};

PayeePickerHeader.propTypes = {
	onShowPayees: PropTypes.func,
	onShowAccounts: PropTypes.func,
	ukPayees: PropTypes.bool,
	onUKPayees: PropTypes.func,
	onInternationalPayees: PropTypes.func,
	showPayees: PropTypes.bool,
	listViewSelected: PropTypes.bool.isRequired,
	onSearchTextChange: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes),
	onToggleListView: PropTypes.func.isRequired,
	handleAddPayee: PropTypes.func.isRequired,
	handleDisplayFullwidth: PropTypes.func,
	searchText: PropTypes.string.isRequired,
	isAddPayeeEnable: PropTypes.bool.isRequired,
	isManageYourPayee: PropTypes.bool,
	isIFTEnabled: PropTypes.bool,
	onSearchTextSubmit: PropTypes.func.isRequired,
	pageLoading: PropTypes.bool.isRequired,
	showPayeePickerToggle: PropTypes.bool.isRequired,
	selectedPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)),
};

export { PayeePickerHeader };
export default withContent({ content: payeePickerContent })(withAddPayee(PayeePickerHeader));
